import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AreaAndVolumeOfSolids = () => (
  <QPhototModuleSubtopic
    title="area and vol of solids"
    videos={[
      "https://www.youtube.com/embed/zH-9KJFbPcs",
      "https://www.youtube.com/embed/q-BX0DtZVdY"
    ]}
    takeaways={[
      { text: "washer method: gap between axis of rotation and the region" },
      { text: "Disc method: no gap" }
    ]}
    questions={[
        {
            image:"/cal_10.jpeg"
        },
        {
            image:"/cal_11.jpeg"
        },
        {
            image:"/cal_12.jpeg"
        },
        {
            image:"/cal_13.jpeg"
        },
        {
            image:"/cal_14.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default AreaAndVolumeOfSolids;
